import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center px-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"52px"},
  class: "mdp-WatcherWarning warning"
}, null, -1)
const _hoisted_3 = { class: "my-4 px-3" }
const _hoisted_4 = { class: "d-flex flex-row-reverse" }

import { AxiosError } from "axios";
import { ApiErrorData } from "@medapro-types/common/common";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

//props

export default /*#__PURE__*/_defineComponent({
  __name: 'WarningModal',
  props: {
    showModal: { type: Boolean },
    title: {},
    message: {}
  },
  emits: ["update:showModal"],
  setup(__props: any, { emit }) {

const props = __props;



//#region General
const { t: $t } = useI18n();

//#endregion

const _showModal = computed({
  get: () => {
    return props.showModal;
  },
  set: (nv) => {
    emit("update:showModal", nv);
  }
});

const closeModal = () => {
  emit("update:showModal", false);
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "header-close-content": "",
    id: "warning-modal",
    modelValue: _showModal.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_showModal).value = $event)),
    class: "px-5",
    title: _ctx.title,
    "hide-footer": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.message), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_b_button, {
          variant: "primary",
          class: "mt-3 px-5",
          onClick: closeModal
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref($t)("OK")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})